import { motion } from "framer-motion";
import { COLORS } from "../constants/colors";

const AccordionItem = ({ title, content, open, onClick }) => {
  return (
    <motion.div
      layout
      initial={{ borderRadius: 12 }}
      onClick={onClick}
      className={`bg-white rounded-xl shadow-md overflow-hidden cursor-pointer border transition-all duration-300 ${
        open ? "shadow-xl" : "hover:bg-sky-50"
      }`}
      style={{
        borderColor: open ? COLORS.primaryLight : "#E5E7EB",
        backgroundColor: open ? COLORS.primaryLight : COLORS.background,
      }}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-5">
        <h3
          className="text-lg font-semibold"
          style={{ color: COLORS.primaryDark }}
        >
          {title}
        </h3>
        <motion.span
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          className="text-xl font-bold"
          style={{ color: COLORS.primary }}
        >
          ▼
        </motion.span>
      </div>

      {/* Content */}
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        transition={{
          duration: 0.4,
          type: "spring",
          stiffness: 120,
          damping: 15,
        }}
        className="px-5 pb-5 text-gray-700 text-base overflow-hidden"
      >
        {content}
      </motion.div>
    </motion.div>
  );
};

export default AccordionItem;
